import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  contactInfo: any;
  USER_INFO: any;

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}
  setShipping(contactInfo) {
    this.contactInfo = contactInfo;
  }
  getShipping() {
    return this.contactInfo;
  }

  updateuserinfoForEshop(payload) {
    const contentHeaders = new HttpHeaders();
    contentHeaders.append('Accept', 'application/json');
    contentHeaders.append('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(
          `${environment.ECARE_URL}/updateuserinfoForEshop.service`,
          payload,
          {headers:contentHeaders}
        );
  }
  
  getUserInfo() {
    return this.http.post(
      `${environment.ECARE_URL}/getUserInfo.service`,
      {},
      this.httpOptions
    ).pipe(
      map((R: any) => {
        this.USER_INFO = R;
        localStorage.setItem('ISLOGIN', 'true');
        this.UTS.setUserInfo(this.USER_INFO);
        return R;
      })
    );
  }
  storePersonalInfo(payload){
     const contentHeaders = new HttpHeaders();
contentHeaders.append('Accept', 'application/json');
contentHeaders.append('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(
      `${environment.ESHOP_URL}/storePersonalInfo`,
      payload,
      {headers:contentHeaders}
    );
  }

  

  logOut() {
    return this.http.post(
      `${environment.ECARE_URL}/logoutUser.service`,
      {},
      this.httpOptions
    );
  }
}
